import React from "react";

const HeaderAttribute = (props) => {
  const { attribute, value } = props;

  return (
    <div className="fs-16">
      <span className="tw:font-bold">{attribute}:&nbsp;</span>
      <span>{value}</span>
    </div>
  );
};

export default HeaderAttribute;
